import user1 from "../assets/images/user1.png";
import user2 from "../assets/images/user2.png";
import user3 from "../assets/images/user3.png";
import user4 from "../assets/images/user4.png";

const reviewsDb = {
  id: "reviews",
  title: "Отзывы наших партнёров",
  items: [
    {
      id: "review-1",
      name: "Иван Петров",
      company: "ООО СтройМеханика",
      image: user1,
      rating: 5, // 👈 управляем количеством звёзд
      text: `
        Работаем с Дизель Гарант уже не первый месяц. Поставки приходят вовремя, без нервотрепки
        и постоянных напоминаний. Документы привозят сразу, качество топлива соответствует тому, о чём договаривались. Отдельный плюс, менеджеры всегда на связи, можно быстро решить любой вопрос
        по ходу поставки.
      `,
    },
    {
      id: "review-2",
      name: "Алексей Смирнов",
      company: "ТрансЛогистик",
      image: user2,
      rating: 5, // 👈 3 звезды будут жёлтые
      text: `
        Начали сотрудничество после того, как обожглись с прошлым поставщиком были задержки и путаница
        с ценами. Здесь пока всё чётко, условия понятные, по стоимости без сюрпризов. За время работы никаких проблем не возникало, поэтому продолжаем заказывать дальше.
      `,
    },
        {
      id: "review-3",
      name: "Алексей Смирнов",
      company: "ТрансЛогистик",
      image: user3,
      rating: 5, // 👈 3 звезды будут жёлтые
      text: `
        Берём топливо не самыми большими объемами, но отношение к нам как к полноценному клиенту. Всегда предупреждают по времени, контролируют доставку, быстро отвечают, если что-то уточняем. На рынке это, честно говоря, редкость. Можем спокойно рекомендовать.
      `,
    },
        {
      id: "review-4",
      name: "Алексей Смирнов",
      company: "ТрансЛогистик",
      image: user4,
      rating: 5, // 👈 3 звезды будут жёлтые
      text: `
       Нравится, что у компании всё системно выстроено. Договорённости соблюдаются, по срокам не подводят, качество подтверждают документами. Когда начали работать на постоянной основе, появились более удобные условия по повторным заказам. Чувствуется, что настроены на долгую работу,
а не на разовые продажи.
      `,
    },
  ],
};

export default reviewsDb;
